import HamburgerMenu from './HamburgerMenu.jsx'
import Title from './Title.jsx'
import DefaultButtons from './DefaultButtons.jsx'
import { AppBar, Toolbar, Slide, useScrollTrigger } from '@mui/material'
import React, { useState } from 'react'
import AllModals from '../Modals/AllModals.jsx'

function HideOnScroll({ children }) {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 24,
  })

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  )
}

function Header() {
  // State to control each modal
  const [isStatsOpen, setStatsOpen] = useState(false)
  const [isRulesOpen, setRulesOpen] = useState(false)
  const [isSettingsOpen, setSettingsOpen] = useState(false)

  return (
    <div>
      <HideOnScroll>
        <AppBar
          id="menu-bar"
          position="fixed"
          color="transparent"
          elevation={0}
          sx={{ zIndex: 800, px: { xs: 1, sm: 2 }, pt: { xs: 1, sm: 1.5 } }}
        >
          <Toolbar
            sx={(theme) => ({
              width: '100%',
              maxWidth: 760,
              minHeight: { xs: '58px', sm: '66px' },
              mx: 'auto',
              px: { xs: 1, sm: 1.5 },
              borderRadius: '20px',
              color: theme.palette.text.primary,
              bgcolor: theme.custom.surface,
              border: `1px solid ${theme.custom.border}`,
              boxShadow: '0 14px 40px rgba(15, 23, 42, 0.12)',
              backdropFilter: 'blur(22px)',
            })}
          >
            <HamburgerMenu />
            <Title />
            <DefaultButtons
              isStatsOpen={isStatsOpen}
              setStatsOpen={setStatsOpen}
              isRulesOpen={isRulesOpen}
              setRulesOpen={setRulesOpen}
              isSettingsOpen={isSettingsOpen}
              setSettingsOpen={setSettingsOpen}
            />
          </Toolbar>
        </AppBar>
      </HideOnScroll>
      <AllModals
        isStatsOpen={isStatsOpen}
        setStatsOpen={setStatsOpen}
        isRulesOpen={isRulesOpen}
        setRulesOpen={setRulesOpen}
        isSettingsOpen={isSettingsOpen}
        setSettingsOpen={setSettingsOpen}
      />
    </div>
  )
}

export default Header
